module.exports = __webpack_public_path__ + "img/1579010132.996f9a4c.jpg";